import { Box, Flex, Text, Input, FormControl, FormLabel, Image, InputRightElement, InputGroup } from '@chakra-ui/react';
import Logo from "../../assets/images/hrms_logo.svg";
import MyDiv from './resetPassword.style';
import { CustomButton, CustomToast } from '../../components';
import * as routesNames from '../../constants/routes';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { useLocation } from 'react-router-dom';
import { Icon } from '@chakra-ui/react'
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'

const ResetPassword = () => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const location = useLocation()
    const email: string = location.state?.email || '';
    const navigate = useNavigate();
    const [show1, setShow1] = useState(false)
    const [show, setShow] = useState(false)
    const handleShow = () => setShow(!show)
    const handleShow1 = () => setShow1(!show1)


    const handleClick = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!password || !confirmPassword) {
            addToast({message: "Please fill in all fields",status: "warning",});
            return;
        }

        if (password.trim() !== password) {
            addToast({message: "Password cannot start or end with spaces",status: "warning",});
            return;
        }

        if (password.length < 8) {
            addToast({message: "Password must be at least 8 characters",status: "warning",});
            return;
        }

        if (password.length > 16) {
            addToast({message: "Password must not exceed 16 characters",status: "warning",});
            return;
        }

        if (!/[A-Za-z]/.test(password)) {
            addToast({message: "Password must contain at least one alphabet (A-Z or a-z)",status: "warning",});
            return;
        }

        // At least one number
        if (!/\d/.test(password)) {
            addToast({message: "Password must contain at least one number (0-9)",status: "warning",});
            return;
        }

        // At least one special character
        if (!/[!@#$%^&*(),.?":{}|<>_\-+=\\[\]/~`;']/.test(password)) {
            addToast({message: "Password must contain at least one special character",status: "warning",});
            return;
        }

        // Cannot be only spaces or punctuation
        if (!/[A-Za-z0-9]/.test(password)) {
            addToast({message: "Password cannot consist solely of spaces or punctuation",status: "warning",});
            return;
        }

        if (password !== confirmPassword) {
            addToast({message: "Passwords do not match",status: "warning",});
            return;
        }
        const payload = { Email: email, NewPassword: password };
        const response = await fetchApi("User/resetpassword", "POST", payload, "", "");
        if (response) {
            navigate(routesNames.LOGIN);
        }
    };

    return (
        <MyDiv>
            <Box className="login-container">
                <Flex className="login-flex-wrapper">
                    {/* Left Section */}
                    <Box className="login-left">
                        <Image src={Logo} alt="HRLENSE Logo" className="login-logo" />
                        <Box className="login-left-content" >
                            <Text className="login-heading font-poppins text_bold text_5xl txt common_color">{"Forgot\nPassword"}</Text>
                            <Text className="login-subheading font-poppins text_regular text_xl low_txt font_dark">
                                {"Create Youre New Password."}
                            </Text>
                        </Box>
                    </Box>

                    {/* Right Section */}
                    <Box className="login-right">
                        <Box className="login-card">
                            <Text className='login-title font-poppins text_semibold text_xl font_dark'>Reset your password</Text>

                            <form onSubmit={handleClick}>
                                <Box className="form-group">
                                    <FormControl id="email" >
                                        <FormLabel className='font-poppins text_medium text_md font_dark'>Enter Your New Password</FormLabel>
                                        <InputGroup>
                                            <Input
                                                type={show1 ? 'text' : 'password'}
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                className="input text_regular font-poppins text_sm font_dark"
                                                placeholder="Please Enter Your New Password"
                                                minLength={6}
                                            />
                                            <InputRightElement width='4.5rem'>
                                                <Icon as={show1 ? ViewIcon : ViewOffIcon} onClick={handleShow1} />
                                            </InputRightElement>
                                        </InputGroup>
                                    </FormControl>
                                </Box>

                                <Box className="form-group">
                                    <FormControl id="otp" >
                                        <FormLabel className='font-poppins text_medium text_md font_dark'>Re-enter Your New Password</FormLabel>
                                        <InputGroup>
                                            <Input className="input text_regular font-poppins text_sm font_dark" type={show ? 'text' : 'password'} placeholder="Confirm your password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            <InputRightElement width='4.5rem'>
                                                <Icon as={show ? ViewIcon : ViewOffIcon} onClick={handleShow} />
                                            </InputRightElement>
                                        </InputGroup>
                                    </FormControl>

                                </Box>



                                <Box className="form-group">
                                    <CustomButton type="submit" title="Save & Login" className='login-button font-poppins btn_theme:hover btn_theme' />
                                </Box>
                            </form>
                        </Box>
                    </Box>
                </Flex>
            </Box>
        </MyDiv>
    )
}
export default ResetPassword;